import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=5bbf3b7b&scoped=true"
import script from "./editDialog.vue?vue&type=script&lang=js"
export * from "./editDialog.vue?vue&type=script&lang=js"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=5bbf3b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf3b7b",
  null
  
)

export default component.exports